<template>
  <div>
    <van-cell
      title="产品信息"
      is-link
      :value="device.model || '请选择产品'"
      @click="showProductPopup = true"
      required
    />

    <!-- 产品选择弹框 -->
    <van-popup
      v-model="showProductPopup"
      position="right"
      :style="{ width: '100%', height: '100%' }"
    >
      <div class="product-popup">
        <div class="popup-header">
          <div class="search-header">
            <van-icon name="cross" class="back-icon" @click="showProductPopup = false" />
            <van-search
              v-model="searchModelVal"
              placeholder="请输入产品型号"
              class="search-input"
              @search="searchModel"
              @clear="clearSearch"
              enterkeyhint="search"
            />
          </div>
        </div>

        <div class="popup-content">
          <!-- 左侧尺寸列表 -->
          <div class="size-list">
            <div class="size-title">产品尺寸</div>
            <div
              v-for="(size, index) of sizeData"
              :key="index"
              class="size-item"
              :class="{ active: sizeVal === size && !isSearchMode }"
              @click="selectSize(size)"
            >
              {{ size }}
            </div>
          </div>

          <!-- 右侧产品列表 -->
          <div class="product-list">
            <div
              v-for="(item, index) of displayProducts"
              :key="index"
              class="product-item"
              :class="{ active: tempModelVal.id === item.id }"
              @click="selectProduct(item)"
            >
              {{ item.name }}
            </div>
            <div v-if="displayProducts.length === 0" class="empty-tip">暂无产品</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectType: 1,
      tabType: 'common',
      commonData: [],
      allData: [],
      sizeData: [],
      productLine: [],
      searchResults: [],
      sizeVal: '',
      modelVal: {},
      tempModelVal: {}, // 临时选中的产品，确认后才会真正设置
      showProductLine: true,
      searchModelVal: '',
      showProductPopup: false,
      isSearchMode: false
    }
  },
  methods: {
    nextPage() {
      this.$emit('nextPage')
    },

    async setCurrentDeviceInfo() {
      await this.$nextTick()
      let item = this.allData.find(ele => ele.name === this.device.model)
      if (!item) return
      this.selectSize(item.size)
      this.modelVal = item
      this.tempModelVal = item
    },

    async getList() {
      let res = await this.$http.getProductList()
      this.allData = res.data
      this.productLine = res.data
      this.sizeData = res.data.map(item => item.size)
      this.sizeData = [...new Set(this.sizeData)]
      this.setCurrentDeviceInfo()
    },

    selectSize(size = '') {
      if (this.isSearchMode) {
        this.isSearchMode = false
        this.searchModelVal = ''
      }
      this.sizeVal = size
      this.productLine = this.allData.filter(item => item.size === size)
    },

    selectTempModel(item) {
      this.tempModelVal = item
    },

    // 点击产品项直接选中并关闭弹窗
    selectProduct(item) {
      this.tempModelVal = item
      this.modelVal = item
      this.device.model = item.name
      this.showProductPopup = false
    },

    searchModel() {
      if (!this.searchModelVal) {
        this.isSearchMode = false
        return
      }

      let arr = this.allData.filter(
        item =>
          ~item.name
            .replace(/\s+/g, '')
            .toLocaleLowerCase()
            .indexOf(this.searchModelVal.replace(/\s+/g, '').toLocaleLowerCase())
      )

      if (!arr || !arr.length) {
        this.$toast('未找到相关产品')
        return
      }

      this.searchResults = arr
      this.isSearchMode = true
    },

    clearSearch() {
      this.searchModelVal = ''
      this.isSearchMode = false

      if (this.modelVal && this.modelVal.size) {
        this.selectSize(this.modelVal.size)
      } else if (this.sizeData.length > 0) {
        this.selectSize(this.sizeData[0])
      }
    }
  },
  watch: {
    device: {
      handler() {
        this.setCurrentDeviceInfo()
      },
      deep: true
    },
    searchModelVal(val) {
      if (!val) {
        this.isSearchMode = false
      }
    }
  },
  mounted() {
    this.getList()
  },
  computed: {
    filteredProductLine() {
      return this.productLine.filter(item => item.showUser === 'yes')
    },
    displayProducts() {
      if (this.isSearchMode) {
        return this.searchResults.filter(item => item.showUser === 'yes')
      } else {
        return this.filteredProductLine
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f7f8fa;

  .popup-header {
    flex-shrink: 0;

    .search-header {
      display: flex;
      align-items: center;
      background-color: #fff;
      padding: 8px 16px;

      .back-icon {
        font-size: 20px;
        margin-right: 10px;
        flex-shrink: 0;
      }

      .search-input {
        flex: 1;
        padding: 0;
        background-color: transparent;

        ::v-deep .van-search__content {
          background-color: #f5f5f5;
        }
      }
    }
  }

  .popup-content {
    display: flex;
    flex: 1;
    overflow: hidden;

    .size-list {
      width: 35%;
      overflow-y: auto;
      background-color: #f5f6f7;
      height: 100%;

      .size-title {
        padding: 10px;
        font-size: 14px;
        border-bottom: 1px solid #ebedf0;
        font-weight: bold;
      }

      .size-item {
        padding: 15px 10px;
        font-size: 14px;
        border-bottom: 1px solid #ebedf0;

        &.active {
          background-color: #fff;
          font-weight: 500;
          color: #1989fa;
          position: relative;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 4px;
            height: 100%;
            background-color: #1989fa;
          }
        }
      }
    }

    .product-list {
      flex: 1;
      overflow-y: auto;
      padding: 0 10px;
      background-color: #fff;

      .product-item {
        padding: 15px 10px;
        font-size: 14px;
        border-bottom: 1px solid #ebedf0;

        &.active {
          color: #1989fa;
        }
      }

      .empty-tip {
        padding: 30px 0;
        text-align: center;
        color: #969799;
        font-size: 14px;
      }
    }
  }
}
</style>
